export enum InteractionSessionEvents {
    USER_INTERACTION = 'interaction',
    SESSION_VERIFICATION = 'session-verification',
    AUDIT_INTERACTION = 'audit-interaction'
}
